import { Splide, SplideSlide } from "@splidejs/react-splide";
import sliderOne from "../img/slieder1.png";
import { Card } from "react-bootstrap";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import imageSliderTwo from "../img/image_se_faire_rappeler.png";
import { Link, useNavigate } from "react-router-dom";
import tikTok from "../img/tik-tok.png";

function PromotionCards() {
  const navigate = useNavigate();

  return (
    <div className="kl-dashboard-content">
      <Splide aria-label="My Favorite Images" options={{ arrows: false, pagination: false }}>
        <SplideSlide>
          <Link to="/consultation">
            <div className="kl-splide-slide">
              <Card className="kl-card" style={{ background: "#091A7A" }}>
                <Card.Body className="kl-card-body">
                  <div>
                    <Card.Title className="kl-card-title-call">
                      Votre copilote financier vous attend
                    </Card.Title>
                    <div className="kl-consultation-offered-card">
                      Consultation Offerte
                    </div>
                    <div style={{ width: "157px", bottom: "8px", position: "absolute" }}>
                      <div className="kl-see-more-button">
                        Se faire rappeler
                        <span className="kl-see-more-icon">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="kl-image-card-call">
                    <img src={imageSliderTwo} alt="Se faire rappeler" />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Link>
        </SplideSlide>

        <SplideSlide className="kl-forfait">
          <Link to="/subscription-list">
            <div className="kl-splide-slide">
              <Card className="kl-card" style={{ background: "#6f19fd" }}>
                <Card.Body className="kl-card-body">
                  <div>
                    <Card.Title className="kl-card-title-sub">
                      Votre liberté prend son envol
                    </Card.Title>
                    <Card.Text className="kl-card-text">
                      Comptaride assure vos arrières pendant que vous visez les étoiles
                    </Card.Text>
                    <div style={{ width: "157px", bottom: "8px", position: "absolute" }}>
                      <div className="kl-see-more-button">
                        voir nos forfaits premium
                        <span className="kl-see-more-icon">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="kl-image-card-sub">
                    <img src={sliderOne} alt="Nos forfait" />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Link>
        </SplideSlide>

        <SplideSlide>
          <div className="kl-splide-slide">
            <Card style={{ width: "auto" }} className="kl-card kl-card-tiktok">
              <Card.Body className="kl-card-body">
                <div>
                  <Card.Title className="kl-card-title-tiktok">
                    Retrouves tous nos conseils sur
                  </Card.Title>
                  <div className="kl-tiktok-image">
                    <img src={tikTok} alt="tik tok" />
                  </div>
                  <div style={{ width: "157px", bottom: "8px", position: "fixed" }}>
                    <Card.Link className="kl-see-more-button" href="#">
                      Nous suivre
                      <span className="kl-see-more-icon">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </span>
                    </Card.Link>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </SplideSlide>
      </Splide>
    </div>
  );
}

export default PromotionCards;
